'use client'

import { Card, CardContent } from '@/components/ui/card'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import { useProductPromotions } from '@/hooks/react-query/products/use-product'
import { useProductDetail } from '@/hooks/zustands/use-product-detail'
import { formatPrice } from '@/lib/utils'
import { useTranslations } from 'next-intl'
import { useEffect } from 'react'
import { ProductPromotionGiftItem } from './product-promotion-gift-item'

export const ProductPromotionGift = ({ productId }: { productId: string }) => {
  const { data: promotionGifts } = useProductPromotions(productId)
  const { giftData, setGiftData } = useProductDetail()
  const firstGift = promotionGifts?.[0]
  const t = useTranslations('title')

  useEffect(() => {
    if (firstGift?.variants?.length) {
      setGiftData({
        id: firstGift?.id || '',
        optionId: firstGift?.variants?.[0]?.id || '',
        price: firstGift?.compare_price || 0,
      })
    }
  }, [setGiftData, firstGift])

  if (
    !promotionGifts ||
    promotionGifts?.length === 0 ||
    !firstGift?.variants?.length
  )
    return null

  return (
    <div className='mx-auto w-full rounded-lg border border-neutral-200'>
      <div className='rounded-lg bg-white shadow-sm'>
        <div className='border-b border-gray-100 bg-neutral-100 px-4 py-2 text-base'>
          {t('promotion')}{' '}
          <span className='font-bold'>{formatPrice(giftData?.price || 0)}</span>
        </div>

        <div className='max-h-[150px] overflow-y-auto p-2'>
          <Card className='overflow-hidden border-0 shadow-none'>
            <CardContent className='flex p-0'>
              <RadioGroup
                value={giftData?.id || ''}
                onValueChange={(val) => setGiftData({ ...giftData, id: val })}
              >
                {promotionGifts?.map((gift, index) => (
                  <RadioGroupItem key={index} value={gift.id}>
                    <ProductPromotionGiftItem
                      gift={gift}
                      isSelected={gift.id === giftData?.id}
                      onSelect={() => setGiftData({ ...giftData, id: gift.id })}
                    />
                  </RadioGroupItem>
                ))}
              </RadioGroup>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  )
}
